/**
 * Serializes an object to a query string using URLSearchParams
 * @param obj - Object to convert to serialized query string
 * @returns Serialized key/val pairs joined with &
 * @see https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
 */
export const objectToQueryString = <T extends Record<string, unknown>>(obj: T) => {
  const searchParams = new URLSearchParams();

  Object.entries(obj).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((arrayValue) => searchParams.append(key, String(arrayValue ?? '')));
    } else {
      searchParams.append(key, String(value ?? ''));
    }
  });

  return searchParams.toString();
};
